import { render, staticRenderFns } from "./DynamicFAQItem.vue?vue&type=template&id=108bd3f4&scoped=true&"
import script from "./DynamicFAQItem.vue?vue&type=script&lang=js&"
export * from "./DynamicFAQItem.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFAQItem.vue?vue&type=style&index=0&id=108bd3f4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108bd3f4",
  null
  
)

export default component.exports